import { useState, useEffect } from "react";
import { API, authFetch } from "@/App";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export default function FavoriteButton({ albumId, size = "default", className = "" }) {
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkFavorite();
  }, [albumId]);

  const checkFavorite = async () => {
    try {
      const res = await authFetch(`${API}/favorites/check/${albumId}`);
      if (res.ok) {
        const data = await res.json();
        setIsFavorite(data.is_favorite);
      }
    } catch (error) {
      console.error("Failed to check favorite status:", error);
    }
  };

  const toggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setLoading(true);
    try {
      const res = await authFetch(`${API}/favorites/${albumId}`, {
        method: "POST",
      });
      
      const text = await res.text();
      
      if (res.ok) {
        const data = JSON.parse(text);
        setIsFavorite(data.is_favorite);
        toast.success(data.message);
      } else {
        let errorMsg = "Failed to update favorite";
        try { errorMsg = JSON.parse(text).detail || errorMsg; } catch {}
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error("Favorite error:", error);
      toast.error("Failed to update favorite");
    } finally {
      setLoading(false);
    }
  };

  const sizeClasses = {
    small: "w-4 h-4",
    default: "w-5 h-5",
    large: "w-6 h-6",
  };

  const buttonSizeClasses = {
    small: "p-1.5",
    default: "p-2",
    large: "p-2.5",
  };

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      className={cn(
        "rounded-full transition-all duration-200",
        "bg-black/60 hover:bg-pink-500 hover:scale-110",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        buttonSizeClasses[size],
        className
      )}
      title={isFavorite ? "Remove from favorites" : "Add to favorites"}
      data-testid={`favorite-btn-${albumId}`}
    >
      <Heart
        className={cn(
          sizeClasses[size],
          "transition-colors",
          isFavorite ? "text-pink-400 fill-pink-400" : "text-white"
        )}
      />
    </button>
  );
}
